import ClipboardJS from 'clipboard/src/clipboard';

new ClipboardJS('#icon-clipboard');
